import { ConfirmationRdvEspaceClient } from '@components/confirmation-rdv-espace-client/models';
import { Block } from '@shared/models';

export const confirmationRdvEspaceClientMock: Block<ConfirmationRdvEspaceClient> = {
  type: 'confirmation-rdv-espace-client',
  data: {
    title: {
      text: `Votre rendez-vous est confirmé !`,
      as: 'span',
    },
    subtitle: `Hâte de vous retrouver autour d'un café (un thé ça marche aussi)`,
  },
};
